import { action, payload } from 'ts-action'
import { getActionType } from '../constants'

export const setCoupon = action(getActionType('Set Coupon'), payload<{ code: string }>())

export const clearCoupon = action(getActionType('Clear Coupon'))
